import { action } from 'satcheljs/lib/legacy';
export default action('updateDockingHeight')(function updateDockingHeight(dockingViewState, topDockingHeight, bottomDockingHeight) {
    dockingViewState.topDockingHeight = topDockingHeight;
    dockingViewState.bottomDockingHeight = bottomDockingHeight;
});
//# sourceMappingURL=updateDockingHeight.js.map